import { ZoomTransformation } from '../../../common/zoom/models/zoom-model';
import { CirclePacking } from '../../models/circlePackingModel';
import { ALPHA_STROKE_CIRCLE, STROKE_CIRCLE } from '../constants';
import { setAlphaColor } from '../dataProcessing/helpers/colorHelpers';

export const circleRender: (
  node: CirclePacking,
  context: CanvasRenderingContext2D,
  zoomTransformation: ZoomTransformation,
  parent?: boolean
) => void = (node, context, zoomTransformation, parent) => {
  context.strokeStyle = setAlphaColor(node.color, parent ? 1 : ALPHA_STROKE_CIRCLE);
  context.lineWidth = (STROKE_CIRCLE * (parent ? 2 : 1)) / zoomTransformation.k;

  context.beginPath();
  context.arc(node.x, node.y, node.r, 0, 2 * Math.PI, true);

  context.stroke();
  context.closePath();
};
